<login-background *letVar="{ params: queryParams$ | async, errorMessage: errorMessage$ | async } as calls">
    <ng-container *ngIf="(isPending$ | async) === false; else isPending" title>
        <span *ngIf="!isEmailInUseError(calls.errorMessage); else emailInUse">Please create your account</span>
        <ng-template #emailInUse>Something went wrong</ng-template>
    </ng-container>

    <ng-container *ngIf="(isPending$ | async) === false">
        <form
            *ngIf="!isEmailInUseError(calls.errorMessage); else emailInUse"
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="10px"
            [formGroup]="form"
            (ngSubmit)="submit(form, calls.params)"
        >
            <mat-form-field>
                <input type="text" #input1 matInput placeholder="First name" formControlName="firstname" autofocus />
                <mat-error>
                    <app-validation-message
                        [touched]="form.controls.firstname.touched"
                        [errors]="form.controls.firstname.errors"
                    ></app-validation-message>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <input type="text" matInput placeholder="Last name" formControlName="lastname" />
                <mat-error>
                    <app-validation-message
                        [touched]="form.controls.lastname.touched"
                        [errors]="form.controls.lastname.errors"
                    ></app-validation-message>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <input type="email" lowercase-inp matInput placeholder="Email" formControlName="email" />
                <mat-error>
                    <app-validation-message
                        [touched]="form.controls.email.touched"
                        [errors]="form.controls.email.errors"
                    ></app-validation-message>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <input type="password" matInput placeholder="Password" formControlName="password" />
                <mat-error>
                    <app-validation-message
                        [touched]="form.controls.password.touched"
                        [errors]="form.controls.password.errors"
                    ></app-validation-message>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <input type="password" matInput placeholder="Confirm password" formControlName="confirmPassword" />
                <mat-error>
                    <app-validation-message
                        [touched]="form.controls.confirmPassword.touched"
                        [errors]="form.controls.confirmPassword.errors"
                    ></app-validation-message>
                </mat-error>
            </mat-form-field>

            <div class="terms-conditions">
                <mat-checkbox formControlName="agreeToTerms"
                    >I agree to the
                    <a rel="noopener noreferrer" target="_blank" href="https://www.clarecontrols.com/home-automation/terms-of-use/"
                        >Terms & Conditions</a
                    >.</mat-checkbox
                >
                <mat-error>
                    <app-validation-message
                        [touched]="form.controls.agreeToTerms.touched"
                        [errors]="form.controls.agreeToTerms.errors"
                    ></app-validation-message>
                </mat-error>
            </div>

            <mat-error *ngIf="calls.errorMessage">
                {{ calls.errorMessage }}
            </mat-error>

            <button type="submit" mat-raised-button color="primary" class="register" [disabled]="isUnableToSubmit">Create account</button>
            <a
                *ngIf="calls.params?.staff !== 'false'"
                fxShow
                mat-stroked-button
                color="secondary"
                class="register"
                fxHide.gt-xs="true"
                routerLink="/signup"
                queryParamsHandling="merge"
            >
                Cancel
            </a>
        </form>
        <ng-container *ngIf="calls.params?.staff === 'false'">
            <div class="or-border">
                <span class="or-span">or</span>
            </div>
            <app-social-sign-in-block></app-social-sign-in-block>
        </ng-container>
        <p *ngIf="calls.params?.staff === 'true'">Already have an account? <a routerLink="/login">Sign in.</a></p>
        <ng-template #emailInUse>
            <mat-error *ngIf="calls.errorMessage">
                {{ calls.errorMessage }}
                <a *ngIf="isEmailInUseError(calls.errorMessage)" (click)="goToLogin(calls.params.inviteCode)">Go to Login</a>
            </mat-error>
        </ng-template>
    </ng-container>
    <ng-template #isPending>
        <clare-spinner text="Registering User"></clare-spinner>
    </ng-template>
</login-background>
